var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"month-number-and-name"},[_c('span',[_c('span',{staticClass:"day"},[_vm._v(_vm._s(_vm.day))]),(_vm.shouldShowIcon)?_c('i',{staticClass:"fe fe-check"}):_vm._e(),_c('small',[_vm._v(_vm._s(_vm.monthLongName)+" "+_vm._s(_vm.yearFull))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }